<template>
    <a-card>
        <div class="title">
            <h3>创新自测</h3>
            <span>
                <ExclamationCircleOutlined/>自测分数
            </span>
        </div>
        <a-descriptions bordered style="margin-top: 20px" >

            <a-descriptions-item  v-for="item in dataList" :key="item.name" :label="item.name" :span="2">{{item.score}}</a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>
<script>
import {selftestApi} from "@/api/innovationService"
    export default {
        name:"index",
        data(){
            return {
                dataList:[]
            }
        },
        mounted() {
            this.getData()
        },
        methods:{
            getData(){
                this.getAction({
                    url:selftestApi.detailScore,
                    params:{
                        companyCode:this.$ls.get("companyCode")
                    }
                }).then(res=>{
                    this.dataList = res
                    console.log(res,'res')
                })
            }
        }
    }
</script>
<style scoped lang="less">
.title {
    border-bottom: 4px solid #000000;
    display: flex;
    h3 {
        font-weight: bold;
    }
    span {
        font-size: 16px;
        margin-top: 4px;
        margin-left: 6px;
        color: #1aad19;
    }
}
</style>
